module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-item"
  }, [_c('h3', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.name) + "\n    "), (_vm.extra) ? _c('span', {
    staticClass: "extra"
  }, [_vm._v(_vm._s(_vm.extra))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm.value || _vm.value === 0) ? _vm.value : '--'))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.valueUnit))])]), _vm._v(" "), (_vm.hasCompareValue) ? [_c('span', {
    staticClass: "compare-name"
  }, [_vm._v(_vm._s(_vm.compareName))]), _vm._v(" "), _c('span', {
    staticClass: "compare-value",
    class: {
      'lower': _vm.isLower, 'higher': _vm.isHigher
    }
  }, [_vm._v(_vm._s(_vm.compareValue ? _vm.compareValue + '%' : _vm.defaultCompareValue))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb6c83b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/dataItem.vue
// module id = 807
// module chunks = 0